/**
 * Created by Ray on 2016/12/26.
 */
import {Component, ViewContainerRef, OnInit} from '@angular/core';
import {Response} from '@angular/http';
import {Router} from '@angular/router';
import {Message} from 'primeng/primeng';
import {Constants} from '../shared/constants';
import {AuthService} from '../shared/service/auth.service';
import {ProgressService} from '../shared/service/progress.service';
import {Validators,FormControl,FormGroup,FormBuilder} from '@angular/forms';
import {ConfirmationService} from 'primeng/api';
import {MsgService} from "../shared/service/message.service";


@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent  implements OnInit{
  loginName = '';
  pwd = '';
  loginform: FormGroup;
  loginImg:string;
  errorMsg = '';

  constructor(private authService:AuthService, private router:Router,
              private constants:Constants, private fb: FormBuilder,  private msgService:MsgService) {
    this.loginImg = 'assets/img/login/login-' + Math.ceil(Math.random() * 1) + '.png';
  }

  ngOnInit() {
    this.loginform = this.fb.group({
      'loginId': new FormControl('', Validators.compose([Validators.required])),
      'password': new FormControl('', Validators.compose([Validators.required]))
    });

  }

  login() {
    this.errorMsg = '';
    if (this.loginName && this.pwd) {
      this.authService.login(this.loginName, this.pwd, data => {
        this.router.navigate([this.authService.redirectUrl]);
      }, error => {
        const errorCode = error.status;
        if (errorCode === 401) {
          this.errorMsg = 'Invalid login name or password.';
        } else if (errorCode === 403){
          this.errorMsg = 'There have been too many unsuccessful login attempts, which caused the account to be locked. Please check with your Smith point of contact to resolve this issue.';
        } else {
          this.errorMsg = 'Login failed.';
        }
        this.msgService.showError('Error', this.errorMsg);
      });
    }else{
      this.errorMsg = 'Please input login name and password.';
      this.msgService.showError('Error', this.errorMsg);
    }
  }
}



// WEBPACK FOOTER //
// C:/Projects/ServiceChain/servicechain2/svc-ui/TRUNK/src/app/login/login.component.ts